var _defs, _text, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-2 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        stroke-linecap: round;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 -6.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Alarm O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 33.47,
    y: 0
  }, "ff"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.29,58.63v-12.55c0-7.96-6.45-14.41-14.41-14.41s-14.41,6.45-14.41,14.41v12.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 59.7,
    y1: 58.63,
    x2: 16.06,
    y2: 58.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 37.88,
    y1: 17.23,
    x2: 37.88,
    y2: 25.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 58.38,
    y1: 25.69,
    x2: 52.4,
    y2: 31.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 66.84,
    y1: 43.96,
    x2: 58.38,
    y2: 43.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 17.3,
    y1: 25.69,
    x2: 23.28,
    y2: 31.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 8.84,
    y1: 43.96,
    x2: 17.3,
    y2: 43.96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmOff);
export default __webpack_public_path__ + "static/media/__Alarm - Off.110ec5a7ba8eb1451e46128d6ab89c32.svg";
export { ForwardRef as ReactComponent };